import { ArrowRight, LockKeyhole, RadioTower } from "lucide-react";
import { useState, type FormEvent } from "react";

import { isSupabaseConfigured, supabase } from "@/lib/supabase";

export function AuthView() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!isSupabaseConfigured) {
      setMessage("Add the Supabase environment variables before signing in.");
      return;
    }
    setIsSending(true);
    setMessage("");
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin,
      },
    });
    setIsSending(false);
    setMessage(
      error
        ? error.message
        : "Magic link sent. You can close this tab after opening the email.",
    );
  }

  return (
    <main className="auth-shell">
      <section className="auth-card">
        <div className="brand-lockup">
          <span className="brand-mark">
            <RadioTower aria-hidden="true" />
          </span>
          <span>Newsroom</span>
        </div>
        <p className="eyebrow">PRIVATE RESEARCH DESK</p>
        <h1>Turn fast-moving coverage into evidence-backed drafts.</h1>
        <p className="auth-copy">
          One private inbox for source discovery, corroboration, duplicate
          coverage, and manual-publication options.
        </p>
        <form className="auth-form" onSubmit={submit}>
          <label>
            <span>Email address</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
            />
          </label>
          <button type="submit" disabled={isSending}>
            {isSending ? "Sending…" : "Send private sign-in link"}
            <ArrowRight aria-hidden="true" />
          </button>
        </form>
        {message ? <p className="form-message">{message}</p> : null}
        <div className="security-note">
          <LockKeyhole aria-hidden="true" />
          <span>
            The URL is not the security boundary. Supabase Auth, the access
            allowlist, and RLS protect every record.
          </span>
        </div>
      </section>
    </main>
  );
}
